export { ABSENCE_STILL_REPORTABLE_HINT, AbsenceQuotaNotice, type AbsenceQuotaNoticeProps } from "./AbsenceQuotaNotice"
